/* Home dashboard views (tabs). Hardcoded: add or change a view here, not in the UI.
   Each view lists the widgets it may show; within it, people still hide/snooze/move (synced per view).
   Experimental lists nothing: it shows every registered widget no other view lists (new widgets land there).
   `company` seeds ?company= when the tab is picked. Widget ids come from widgets/registry.ts. */
import type { IWidgetDefinition } from "./homeDashboard.types"

export interface IViewDefinition {
  id: string
  name: string
  /** Widget ids in this view */
  widgets: string[]
  /** Show every widget that no other view lists, instead of `widgets` */
  unassigned?: boolean
  /** Default company filter slugs applied when switching to this view */
  company?: string[]
}

export const HOME_VIEW_ID = "home"
/** Cross-company overview; product-only widgets (VidMax docs, bets) live in their product's view */
const HOME_VIEW: IViewDefinition = {
  id: HOME_VIEW_ID,
  name: "Home",
  widgets: [
    "mission",
    "my-work",
    "incidents",
    "health",
    "deploys",
    "revenue",
    "ad-spend",
    "product-pulse",
    "gateway-spend",
    "eng-delivery",
    "data-coverage",
    "aix-todos",
  ],
}

export const VIEWS: IViewDefinition[] = [
  HOME_VIEW,
  {
    id: "vidmax",
    name: "VidMax",
    widgets: ["mission", "bets", "docs", "incidents", "health", "deploys", "revenue", "product-pulse"],
    company: ["vidmax"],
  },
  { id: "experimental", name: "Experimental", widgets: [], unassigned: true },
]

/** Unknown ids (removed view, stale link) fall back to Home */
export const viewFor = (id: string | undefined): IViewDefinition => VIEWS.find((view) => view.id === id) ?? HOME_VIEW

export const widgetsForView = (defs: IWidgetDefinition[], view: IViewDefinition): IWidgetDefinition[] => {
  if (!view.unassigned) return defs.filter((def) => view.widgets.includes(def.id))
  const assigned = new Set(VIEWS.flatMap((v) => (v.unassigned ? [] : v.widgets)))
  return defs.filter((def) => !assigned.has(def.id))
}
